import { createFileRoute } from "@tanstack/react-router";
import { BabylonSceneWrapper } from "@/babylon/components/BabylonSceneWrapper";
import { ImmediateStrategy } from "@/pages/3d/memory/ImmediateStrategy";

export const Route = createFileRoute("/demo/3d/memory/immediate")({
  component: () => (
    <BabylonSceneWrapper>
      <ImmediateStrategy />
    </BabylonSceneWrapper>
  ),
});
